import { useMemo } from 'react'
import { useTranslation } from 'src/utils/i18n'
import StepLayout from './StepLayout'

const GoogleDrive = () => {
  const { t } = useTranslation('commonAndroid')
  const step = useMemo(
    () => [
      {
        title: <span>{t('Open the Settings app on the target Android phone and click Accounts and Backup')}.</span>,
        img: [
          {
            src: '/images/login/backup1.png'
          }
        ]
      },
      {
        title: <span>{t('Click Backup data under Google Drive')}.</span>,
        img: [
          {
            src: '/images/login/backup2.png'
          }
        ]
      },
      {
        title: (
          <span>
            {t(
              'Make sure the Google account is signed in and click Back up now If there is no account under Account storage sign in first The time displayed below Backup by Google One is the last time you backed up'
            )}
            .
          </span>
        ),
        img: [
          {
            src: '/images/login/backup3.png'
          }
        ]
      }
    ],
    [t]
  )

  return <StepLayout title={t('Turn on Google Drive back up')} step={step} />
}

export default GoogleDrive
